import Api from '.';
import { endpoints } from './endpoints';

export default class UserApi extends Api {
    menuRoleWise(data) {
        let url = this.buildUrl(endpoints.login.menuRoleWise)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
}